require('./suggestList.scss');

const PropTypes = require('prop-types');

// @ vendor
const React = require('react');
const classNames = require('classnames');
const Autosuggest = require('react-autosuggest');
const noop = require('lodash/utility/noop');
const { FormattedText } = require('core/i18n').i18n;

class SuggestList extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            trigger: false,
            readOnly: false,
            value: '',
            suggestions: [],
            noResults: false
        }

        this.setData = this.setData.bind(this);

        this.handleClose = this.handleClose.bind(this);

        this.onInputChange = this.onInputChange.bind(this);
        this.handleOnSuggestionsFetchRequested = this.handleOnSuggestionsFetchRequested.bind(this);
        this.handleOnSuggestionsClearRequested = this.handleOnSuggestionsClearRequested.bind(this);
        this.handleOnSuggestionSelected = this.handleOnSuggestionSelected.bind(this);

        this.getSuggestionValue = this.getSuggestionValue.bind(this);
        this.shouldRenderSuggestions = this.shouldRenderSuggestions.bind(this);

        this._ref = this._ref.bind(this);
    }

    componentWillMount(){
        this.setData(this.props.optionsList, this.props.value);
    }

    componentWillReceiveProps(nextProps) {
        this.setData(nextProps.optionsList, nextProps.value);
    }

    onInputChange(event, { newValue }) {
        this.setState({
            value: newValue
        });
    }

    getSectionSuggestions(section) {
        return section.items;
    }

    getSuggestionValue(suggestion) {
        return suggestion.name;
    }

    getSuggestions(value) {
        const escapedValue = this.escapeRegexCharacters(value.trim());

        if (escapedValue === '') {
            return [];
        }

        const regex = new RegExp(escapedValue, 'i');

        const result = this.props.optionsList.filter(item => regex.test(item.name));

        this.setState({
            noResults: (result.length == 0)
        });

        return result;
    }

    getSuggestionsByCode(code, optionsList) {
        const escapedCode = this.escapeRegexCharacters(code.trim());

        if (escapedCode === '') {
            return [];
        }

        const regex = new RegExp(escapedCode, 'i');

        return optionsList.filter(item => regex.test(item.code));
    }

    setData(optionsList, value) {
        if (optionsList.length > 0) {
            const newValue = (value == null) ? '' : value;
            const defaultValue = this.getSuggestionsByCode(newValue.toString(), optionsList);
            if (defaultValue[0]) {
                this.setState({
                    value: defaultValue[0].name,
                    readOnly: true,
                });
            } else {
                this.setState({
                    value: '',
                    readOnly: false,
                });
            }
        }
    }

    _ref(ref) {
        this.el = ref;
    }

    escapeRegexCharacters(str) {
        return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    }

    handleClose() {
        const source = {
            value: ''
        }
        this.props.onChange(source);
        this.handleOnSuggestionsClearRequested();
        this.setState({
            value: '',
            readOnly: false
        });
    }

    handleOnSuggestionSelected(event, { suggestion }) {
        event;
        const source = {
            value: suggestion.code
        }
        this.props.onChange(source);

        this.setState({
            readOnly: true
        });

        this.handleOnSuggestionsClearRequested();
    }

    handleOnSuggestionsClearRequested() {
        this.setState({
            suggestions: []
        });
    }

    handleOnSuggestionsFetchRequested({ value }) {
        this.setState({
            suggestions: this.getSuggestions(value)
        });
    }

    shouldRenderSuggestions(value) {
        return ((!this.state.readOnly) && (value.trim().length > 2));
    }

    renderSuggestion(suggestion) {
        return (
            <span>{suggestion.name}</span>
        );
    }

    render() {
        const {
            disabled,
            label,
            errorState,
            errorMessage,
            placeholder,
            instructionsMessage,
            id,
            optionalText,
            optionalElement,
            onFocus,
        } = this.props;

        const noResultsContent = (this.state.noResults) ?
        (
            <div className="react-autosuggest__no-result">
                <FormattedText value="common-errorNoResults"/>
            </div>
        ) : null;
        const className = classNames(
            'react-autosuggest react-autosuggest--complex',
            { 'ok-input--error': errorState },
            { 'react-autosuggest--error': errorState }
        );
        const inputClassName = classNames(
            'react-autosuggest__input',
            { 'react-autosuggest__input--readonly': this.state.readOnly },
            { 'ok-input--error': errorState }
        );

        const labelId = `lbl_${id}`;
        const inputId = `inp_${id}`;
        const messageId = `text_${id}`;

        let labelElement, messageElement, optionalTextContent, optionalElementContent = null;

        if (optionalText) {
            optionalTextContent = (
                <span className="ok-input__optional-text">
                    {optionalText}
                </span>
            );
        }

        if (optionalElement) {
            optionalElementContent = (
                <span className="ok-input__optional-text">
                    {optionalElement}
                </span>
            );
        }

        if (label) {
            labelElement = (
                <label id={labelId} className="ok-input__label">
                    {label}{optionalTextContent}{optionalElementContent}
                </label>
            );
        }

        const message = errorState ? errorMessage : instructionsMessage;
        if (message) {
            messageElement = (
                <span id={messageId} className="ok-input__message">
                    {message}
                </span>
            );
        }

        const { suggestions, value } = this.state;
        const inputProps = {
            className: inputClassName,
            placeholder,
            value,
            onChange: this.onInputChange,
            id: inputId,
            disabled: disabled,
            readOnly: this.state.readOnly,
            ...( onFocus && { onFocus: onFocus } ),
        }

        let closeButton = (this.state.readOnly) ? (<span className="react-autosuggest__close" onClick={this.handleClose}></span>) : null;
        closeButton = (!disabled) ? closeButton : null;

        return (
            <div className={className} id={name}>
                {labelElement}
                <div>
                    <Autosuggest
                        inputProps={inputProps}
                        suggestions={suggestions}
                        onSuggestionsFetchRequested={this.handleOnSuggestionsFetchRequested}
                        onSuggestionsClearRequested={this.handleOnSuggestionsClearRequested}
                        onSuggestionSelected={this.handleOnSuggestionSelected}
                        getSuggestionValue={this.getSuggestionValue}
                        renderSuggestion={this.renderSuggestion}
                        shouldRenderSuggestions={this.shouldRenderSuggestions}
                        focusFirstSuggestion={false}
                    />
                    {closeButton}
                    {noResultsContent}
                </div>
                {messageElement}
            </div>
        );
    }

}

SuggestList.propTypes = {
    value: PropTypes.oneOfType([ PropTypes.string, PropTypes.number]),
    disabled: PropTypes.bool,
    label: PropTypes.string,
    errorState: PropTypes.bool,
    errorMessage: PropTypes.string,
    placeholder: PropTypes.string,
    instructionsMessage: PropTypes.string,
    onChange: PropTypes.func,
    onFocus: PropTypes.func,
    id: PropTypes.string,
    optionalText: PropTypes.string,
    optionalElement: PropTypes.object,
    optionsList: PropTypes.array
};

SuggestList.defaultProps = {
    disabled: false,
    errorState: false,
    optional: false,
    onChange: noop,
    onFocus: null,
    id: "okInputDetaultId",
    optionsList: []
}

module.exports = SuggestList;